import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../auth.service';
import { FormService } from '../../services/form.service';
import { UserRequest } from '@generativ/much-smarter-models';
import { FeedbackService } from '../../feedback/feedback.service';
import { environment } from '../../../../environments/environment';
import { Intercom } from '../../intercom/intercom.service';
import { StudentService } from '../../../pages/student/student.service';
import { Subscription } from 'rxjs';
import { EntryDictionary, LogInType } from '@generativ/ms-student-types';
import { ContentfulService } from '../../../shared/contentful.service';
import { NgClass } from '@angular/common';
import { FeedbackComponent } from '../../feedback/feedback/feedback.component';


@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, NgClass, ReactiveFormsModule, RouterLink, FeedbackComponent]
})
export class SignInComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  signInForm: UntypedFormGroup;
  loading = true;
  content: LogInType;

  constructor(public formService: FormService,
              private authService: AuthService,
              private feedbackService: FeedbackService,
              private studentService: StudentService,
              private router: Router,
              private intercom: Intercom,
              private contentfulService: ContentfulService
  ) {
    this.signInForm = this.formService.createForm(this.formOptions);
    this.contentfulService.getStudentEntry(EntryDictionary.LogIn.logIn).then(
      (entry) => {
        this.content = new LogInType(entry);
        this.loading = false;
      }
    );
  }

  ngOnInit() {
    // If user is authenticated redirect to home
    if (this.authService.isAuthenticated() && this.authService.currentStudent) {
      this.router.navigate(['/login/location-and-game']);
    }
    if (this.authService.isAuthenticated() && !this.authService.currentStudent) {
      this.getProfileSubscription();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.signInForm)) {
      const user = new UserRequest.Login();
      this.loading = true;
      user.parse(this.signInForm.value);
      this.subscriptions.add(this.authService.signIn(user).subscribe(
        (email) => {
          this.feedbackService.success(`Welcome ${email}`, true);
          this.intercom.shutdown();
          this.intercom.boot({
            app_id: environment.intercom.appId,
            widget: {
              activator: '#intercom'
            },
            email
          });
          // Navigate to url user was before or '/'
          this.getProfileSubscription();
        },
        (err) => {
          this.feedbackService.error(err, true);
          this.loading = false;
        }
      ));
    }
  }

  private get formOptions(): Record<string, unknown> {
    return {
      email: [
        null,
        Validators.compose([
          Validators.required,
          Validators.email
        ])
      ],
      password: [
        null,
        Validators.compose([
          Validators.required
        ])
      ]
    };
  }

  private getProfileSubscription() {
    this.subscriptions.add(this.studentService.getProfile()
      .subscribe(student => {
        if (student) {
          this.authService.setCurrentStudent(student);
          const redirectUrl = `/login/location-and-game`;
          this.router.navigate([redirectUrl]);
          this.loading = false;
        }
      }, error => {
        this.feedbackService.error(error, true);
        this.loading = false;
      }));
  }
}
